<!--
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-10-09 16:58:10
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-10-18 19:52:42
 * @FilePath: /streamline_detail/src/views/home/components/newProductBaseInfo/goods-price-component.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-if="handPriceVo" class="product-left" :class="{ 'product-left__super': superColor }">
    <div class="usually-content">
      <div class="price-discount-wrapper">
        <span v-if="handPriceVo.handPriceCent" class="price">
          <em>¥</em>
          <span class="price-detail">{{ handPriceVo.handPriceCent / 100 }}</span>
          <!-- 十亿补贴只展示补贴价,不展示券后价 -->
          <span
            v-if="handPriceVo.couponDownPriceCent > 0 && !billiontBounsAmount"
            class="coupon-price"
            >券后价</span
          ></span
        >
        <template v-if="discountTag">
          <span
            v-if="Number(discountTag) < 9"
            class="discount"
            :style="{
              backgroundImage: `url(${$setPicSize(bgImage)})`
            }"
          >
            <em class="count">{{ discountTag }}</em> <em>折</em></span
          >
          <!-- 调整else判断逻辑 兼容发售价没返回的情况 二奢不返回发售价 -->
          <span v-else class="discount_unit">
            <span v-if="dataInfo.infoType == 1000"
              >省¥{{ handPriceVo.debutPrice / 100 - handPriceVo.handPriceCent / 100 }}</span
            >
          </span>
        </template>
      </div>
      <!-- 命中条件： 十亿补贴  -->
      <div v-if="billionLevel && billiontBounsAmount" class="billion-desc">
        <span class="desc">补贴价</span>
        <div class="price">
          <img
            src="
             https://pic3.zhuanstatic.com/zhuanzh/7c26636a-f22b-474e-a91e-e6eebd89a90c.png
            "
            alt=""
          />
          <span class="tips">已补{{ billiontBounsAmount }}</span>
        </div>
      </div>
      <!-- 参考价 发售价等 -->
      <div class="price-wrapper">
        <!-- 发售价 -->
        <span
          v-if="handPriceVo.debutPrice"
          v-zpm="{
            sortid: 7,
            sortname: '发售价',
            legoareabackup: {
              sortName: '发售价',
              sortId: 7
            },
            areaexposure: 105
          }"
          class="sell-price"
          @click="showInconPopup"
          >{{ handPriceVo.debutPriceTitle }}<span>¥{{ handPriceVo.debutPrice / 100 }}</span>
        </span>
        <!-- 券前价 -->
        <span
          v-else-if="
            handPriceVo.priceCent &&
            handPriceVo.priceCent != handPriceVo.handPriceCent &&
            !billionLevel &&
            dataInfo.infoType == 1000
          "
          v-zpm="{
            sortid: 8,
            sortname: '券前价',
            legoareabackup: {
              sortName: '券前价',
              sortId: 8
            },
            areaexposure: 105
          }"
          class="sell-price"
          >券前价<span>¥{{ handPriceVo.priceCent / 100 }}</span>
        </span>
        <span v-if="handPriceVo.newPriceCent" class="line"></span>
        <!-- 新品价 -->
        <div v-if="handPriceVo.newPriceCent" class="new-price-wrap" @click="showInconPopup">
          <span class="new-price"
            >{{ handPriceVo.newPriceCentTitle }}¥{{ handPriceVo.newPriceCent / 100 }}</span
          >
        </div>
        <div
          v-if="showIcon"
          v-zpm="{
            sortid: 9,
            sortname: '价格说明',
            legoareabackup: {
              sortName: '价格说明',
              sortId: 9
            },
            areaexposure: 105
          }"
          class="icon"
          @click="showInconPopup"
        >
          <img
            v-if="!superColor"
            src="https://pic5.zhuanstatic.com/zhuanzh/ae2cebb0-f5e1-4d38-bb7a-8a6230f3ec91.png"
            alt=""
          />
          <img
            v-else
            src="https://pic5.zhuanstatic.com/zhuanzh/6cb75868-3b1b-4b27-a5a8-ce8e7eb6989c.png"
            alt=""
          />
        </div>
      </div>
      <!-- 性价比解读 -->
      <costPerformance
        :superColor="superColor"
        :costPerformanceText="costPerformanceText"
        :fineDiscount="handPriceVo.handPricePremiumContentNew ? null : fineDiscount"
      />
    </div>
    <!-- 新品价弹窗 -->
    <new-price-popup
      ref="newPricePopupRef"
      :newPriceExplain="{ ...handPriceVo.newPriceExplain, newPriceCent: handPriceVo.newPriceCent }"
    ></new-price-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { defineComponent, computed, ref } from '@vue/composition-api'
import { Dialog, Popup } from '@zz-common/zz-ui'
import newPricePopup from './new-price-popup.vue'
import costPerformance from './cost-performance.vue'
Vue.use(Dialog).use(Popup)
export default defineComponent({
  props: {
    dataInfo: {
      type: Object,
      default: () => {}
    },
    superLevel: {
      type: Boolean,
      default: false
    },
    billionLevel: {
      type: Boolean,
      default: false
    },
    handPriceVo: {
      type: Object,
      default: () => {}
    },
    actInfoVo: {
      type: Object,
      default: () => {}
    },
    superColor: {
      type: Boolean,
      default: false
    },
    showcostPerformance: {
      type: Boolean,
      default: true
    },
    costPerformanceText: {
      type: String,
      default: ''
    },
    fineDiscount: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    newPricePopup,
    costPerformance
  },

  setup(props) {
    const newPricePopupRef = ref(null)

    const billiontBounsAmount = computed(() => {
      const { actInfoVo = null } = props
      return (actInfoVo && actInfoVo.bounsAmount && actInfoVo.bounsAmount / 100) || ''
    })

    /**
     * $ 折扣标识
     */
    const discountTag = computed(() => {
      const tag = props.handPriceVo.discountTag || ''
      if (tag) {
        return tag.slice(0, tag.length - 1) || ''
      }
      return false
    })
    const bgImage = computed(() => {
      //大促样式
      if (props.superColor) {
        if (discountTag.value.includes('.')) {
          return 'https://pic4.zhuanstatic.com/zhuanzh/9f3da3f5-9e77-4b5b-8a96-89b72c93eb9d.png'
        } else {
          return 'https://pic1.zhuanstatic.com/zhuanzh/d5a893c1-0d56-443f-b643-629e2ba34581.png'
        }
      } else {
        if (discountTag.value.includes('.')) {
          return 'https://pic2.zhuanstatic.com/zhuanzh/874c0065-5fba-4b2e-b40e-f9ccab2e61aa.png'
        } else {
          return 'https://pic6.zhuanstatic.com/zhuanzh/69e2b606-a7c1-4e91-a389-187f9733d674.png'
        }
      }
    })
    /**
     * $ 是否展示新品价说明弹窗
     */
    // TODO: 二奢融合 新机价弹窗
    const showIcon = computed(() => {
      const { debutPrice, newPriceCent, newPriceExplain } = props.handPriceVo
      if (!newPriceExplain) return false
      return Boolean(debutPrice) || Boolean(newPriceCent)
    })

    function showDialog(content) {
      const message =
        content &&
        content.map((item) => {
          return `<div><span style="font-weight: bold">${item.title}</span> : ${item.text}</div>`
        })
      if (message) {
        Dialog({
          title: '价格说明',
          message: message.join(' '),
          closeOnClickOverlay: true,
          confirmButtonText: '我知道了'
        }).then(() => {
          // on close
        })
      }
    }
    const showInconPopup = () => {
      const { debutPrice, newPriceCent, newPriceExplain, debutPriceExplain } = props.handPriceVo
      if (!newPriceExplain) return false
      // 发售价
      if (debutPrice && !newPriceCent) {
        const content = debutPriceExplain || ''
        const message =
          content &&
          content.map((item) => {
            return `<div><span style="font-weight: bold">${item.title}</span> : ${item.text}</div>`
          })
        if (message) {
          Dialog({
            title: '价格说明',
            message: message.join(' '),
            closeOnClickOverlay: true,
            confirmButtonText: '我知道了'
          }).then(() => {
            // on close
          })
        }
      } else {
        // 新机价
        newPricePopupRef.value.newpricePopupShow = true
      }
    }
    return {
      discountTag,
      showDialog,
      showIcon,
      bgImage,
      newPricePopupRef,
      showInconPopup,
      billiontBounsAmount
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
%base {
  color: #111111;
  font-weight: 300;
  font-size: 20px;
  font-family: PingFangSC-Light, PingFang SC;
  line-height: 20px;
}
.product-left {
  display: flex;
  padding-right: 16px;

  .usually-content {
    @extend %base;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;

    .price-discount-wrapper {
      display: flex;
      align-items: flex-end;
      margin-right: 12px;
    }

    .billion-desc {
      display: flex;
      align-items: flex-end;
      margin-right: 12px;

      .desc {
        position: relative;
        top: -1px;
        margin-right: 6px;
        color: #ffffff;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
      }
      .price {
        img {
          position: relative;
          right: -1px;
          width: 12px;
          height: 24px;
        }
        .tips {
          display: flex;
          align-items: center;
          height: 24px;
          padding-right: 7px;
          padding-left: 1px;
          color: #ff483c;
          font-weight: 300;
          font-size: 18px;
          font-family: PingFangSC-Light, PingFang SC;
          background: #fff;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }

    .price {
      display: flex;
      align-items: flex-end;
      .price-detail {
        position: relative;
        top: 8px;
        color: #000000;
        font-size: 64px;
        font-family: Akrobat-ExtraBold;
        line-height: 60px;
      }
      .coupon-price {
        position: relative;
        top: -1px;
        margin-left: 8px;
        color: #111111;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 22px;
      }
      em {
        margin-right: 4px;
        color: #000000;
        font-weight: 800;
        font-size: 36px;
        font-family: Avenir-Heavy, Avenir;
        line-height: 30px;
      }
    }
    .discount {
      position: relative;
      top: -1px;
      display: flex;
      align-items: center;
      margin-left: 6px;
      padding: 2px 0;
      padding-right: 7px;
      padding-left: 12px;
      color: #ffffff;
      font-weight: 400;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      background-repeat: no-repeat;
      background-position: top left;
      background-size: 100% 100%;
      border-radius: 4px;
      opacity: 0.96;
      em {
        font-size: 18px;
      }
    }
    .discount_unit {
      margin-left: 8px;
    }

    .price-wrapper {
      position: relative;
      top: -1px;
      display: flex;
      align-items: center;
      margin-right: 6px;
      &:empty {
        display: none;
      }
      .line:first-child {
        display: none;
      }
      &.no-show-price-wrapper {
        position: relative;
        top: -1px;
        margin-left: 20px;
      }
      // &.show-price-wrapper {
      //   width: 100%;
      //   margin-left: 0;
      // }

      .price-tips {
        margin-right: 12px;
      }
    }
    .sell-price {
      // margin-left: 8px;
      > span {
        text-decoration: line-through;
      }
    }
    .line {
      position: relative;
      width: 1px;
      height: 18px;
      margin-left: 12px;
      padding-left: 12px;
      opacity: 0.7;
      &::after {
        @include hairline(#c6c6c6);
        border-left-width: 1px;
      }
    }

    .new-price-wrap {
      display: flex;
      align-items: flex-end;
    }
    .icon {
      position: relative;
      width: 10px;
      height: 18px;
      margin-left: 6px;
      img {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        margin-top: -0.15px;
      }
    }
  }

  &__super {
    margin-bottom: 20px;
    padding-right: 0;
    .usually-content {
      margin-top: 24px;
      color: #ffffff;
      .price {
        em {
          position: relative;
          top: 2px;
          color: #ffffff;
          color: #ffffff;
          font-weight: 800;
          font-size: 36px;
          font-family: Avenir-Heavy, Avenir;
          line-height: 26px;
        }
        .price-detail {
          color: #ffffff;
          font-weight: 500;
          font-size: 64px;
          font-family: Akrobat-ExtraBold;
          line-height: 56px;
        }
        .coupon-price {
          color: #ffffff;
        }
      }
      .discount {
        // margin-right: 8px;
        color: #ff483c;
        background-repeat: no-repeat;
        background-position: top left;
        background-size: 100% 100%;
        background-size: 100% 100%;
      }

      .line {
        position: relative;
        margin-left: 12px;
        padding-left: 12px;
        &::after {
          @include hairline(#fff);
          border-left-width: 1px;
        }
      }
    }
  }
}
</style>
